import React from 'react';

import { InfoTray } from 'src/components';
import ModalBackdrop from 'src/components/modal-backdrop/old-style/modal-backdrop';
import './disclaimer.scss';

export default function Disclaimer(props) {
	const disclaimerHeader = () => (
		<div className="disclaimer-header">
			<h3 className="is-hidden-mobile">Disclaimer</h3>
			By selecting 'View offer', you agree to the Vodacom disclaimer.
		</div>
	);

	const disclaimerBody = () => (
		<div className="disclaimer-body">
			<div>
				* The <b className="is-hidden-mobile">repayment</b> amount could change
				based on what you select as a repayment percentage.
			</div>
			<div>
				* Collections are taken directly off your daily transaction prior to settlement into
				your account.
			</div>
			<div>
				* The amount taken daily will be based on a percentage that you select.</div>
			<div>
				* This allows for fluctuation in your daily income as you do not have a fixed daily
				payment.
			</div>
			<div>
				* All fees are calculated upfront, no penalties and no surprises.
			</div>
			<br />
			<div>
				This Business Cash Advance is brought to you by{' '}
				<b className="is-hidden-mobile">Vodacom Financial Services</b>
				<span className="is-hidden-tablet">Vodacom Financial Services</span>
				.
			</div>
		</div>
	);

	const disclaimerFooter = () => (
		<div className="disclaimer-footer">
			<button
				className="button is-primary is-fullwidth"
				onClick={() => {
					props.setShow(false);
				}}
				automationid="BCA_Button_Close_Modal"
			>
				Close
			</button>
		</div>
	);

	return (
		<div className="Disclaimer">
			<div className="is-hidden-mobile">
				<ModalBackdrop>
					{disclaimerHeader()}
					{disclaimerBody()}
					{disclaimerFooter()}
				</ModalBackdrop>
			</div>
			<div className="is-hidden-tablet">
				<InfoTray
					selected={true}
					setSelected={(val) => props.setShow(val)}
					title={'Disclaimer'}
					isFullscreen={true}
				>
					<p className="top-mobile-page-title navbar-title-mobile is-hidden-tablet">
						Get Financed
					</p>
					{disclaimerHeader()}
					{disclaimerBody()}
				</InfoTray>
			</div>
		</div>
	);
} 